import cls from "@fvilers/cls";
import { ComponentPropsWithRef, ReactNode } from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import styles from "./Dropzone.module.css";

type DropzoneProps = {
  children: ReactNode;
  dragging?: boolean;
  inputProps: DropzoneInputProps;
  loading?: boolean;
  rootProps: DropzoneRootProps;
} & ComponentPropsWithRef<"div">;

type PropsAs<T extends React.ElementType> = {
  as?: T;
} & ComponentPropsWithRef<T>;

export function Dropzone({
  children,
  className,
  dragging,
  inputProps,
  loading,
  rootProps,
  ...props
}: DropzoneProps) {
  return (
    <div
      className={cls(styles.Dropzone, className)}
      data-dragging={dragging ? "true" : undefined}
      data-loading={loading ? "true" : undefined}
      {...rootProps}
      {...props}
    >
      <input {...inputProps} />
      {children}
    </div>
  );
}

export function DropzoneContent<T extends React.ElementType = "div">({
  as,
  className,
  ...props
}: PropsAs<T>) {
  const Component = as || "div";
  return (
    <Component className={cls(styles.DropzoneContent, className)} {...props} />
  );
}

export function DropzoneDragging<T extends React.ElementType = "div">({
  as,
  className,
  ...props
}: PropsAs<T>) {
  const Component = as || "div";
  return (
    <Component className={cls(styles.DropzoneDragging, className)} {...props} />
  );
}

export function DropzoneLoading<T extends React.ElementType = "div">({
  as,
  className,
  ...props
}: PropsAs<T>) {
  const Component = as || "div";
  return (
    <Component className={cls(styles.DropzoneLoading, className)} {...props} />
  );
}
